import * as angular from 'angular';

export class LabourCostsFactory {
    private apiRoot: string = '/api/v1/companies';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    create(companyId, issueId, labour) {
        return this.$http.post(
            `${this.apiRoot}/${companyId}/issues/${issueId}/labourcosts/`,
            labour
        );
    }

    update(companyId, issueId, labourId, labour) {
        return this.$http.patch(
            `${this.apiRoot}/${companyId}/issues/${issueId}/labourcosts/${labourId}/`,
            labour
        );
    }

    remove(companyId, issueId, labourId) {
        return this.$http.delete(
            `${this.apiRoot}/${companyId}/issues/${issueId}/labourcosts/${labourId}/`
        );
    }
}

angular
    .module('app')
    .service('LabourCostsFactory', LabourCostsFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/labour-costs.factory.ts